export enum SideOptionTabs {
  Conditions,
  Settings,
}
